module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAASUlEQVQImW3NoQ2AMABE0demYTJGQILE1oFjAVgB1xERWEwJCfDkiX/h6NoGG3oEFEwJK7JHxhkx+Brjzwhibb7tCXM9vZMFywV7sQnzIBFy2AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Marker.png
// module id = 1HwB
// module chunks = 1